module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_ny_lb3@2x.9e1eff53.png";